import { createSlice } from '@reduxjs/toolkit';
import { Auth } from 'aws-amplify';
import { onError } from '../libs/errorLib';
import { DATACOR_MULTIPLEXER_URL } from '../libs/constantsLib';
import { AppDispatch } from './index';
import { BatchTicket } from '../types/BatchTicket.types';
import { SliceState } from '../types/store/BatchTicketStore.types';

const initialState: SliceState = {
    batchTicketSet: {
        isLoading: false,
        isLoadingBatchTicket: false,
        batchTickets: [],
        batchTicketsByWarehouseId: {},
    },
};

const slice = createSlice({
    name: 'batchTickets',
    initialState: initialState,
    reducers: {
        batchTicketsLoading: (state, action) => {
            state.batchTicketSet.isLoading = action.payload;
        },
        getBatchTicketsSuccess: (state, action) => {
            state.batchTicketSet.batchTickets = action.payload.batchTickets.map(
                (batchTicket: BatchTicket) => {
                    const randomColor =
                        'hsl(' + Math.random() * 360 + ', 20%, 65%)'; //this should eventually come from DB and be set by user when batch is created
                    return { ...batchTicket, backgroundColor: randomColor };
                }
            );
            state.batchTicketSet.batchTicketsByWarehouseId =
                state.batchTicketSet.batchTickets.reduce((r, a) => {
                    r[a.Whs] = [...(r[a.Whs] || []), a];
                    return r;
                }, {});
            state.batchTicketSet.isLoading = action.payload.isLoading;
        },
    },
});

export default slice.reducer;

// Actions
export const { batchTicketsLoading, getBatchTicketsSuccess } = slice.actions;

export const getBatchTickets = () => async (dispatch: AppDispatch) => {
    dispatch(batchTicketsLoading(true));
    const sessionData: any = await Auth.currentSession();
    await fetch(DATACOR_MULTIPLEXER_URL + 'batchtickets?includesteps=true', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + sessionData.idToken.jwtToken,
            'Ocp-Apim-Trace': 'True',
            'Ocp-Apim-Subscription-Key': '536572ce1293439e9147aac7511889dd',
        },
    })
        // By design, the instant state and value of a promise cannot be inspected synchronously from code, without calling the then() method
        .then((dataWrappedByPromise) => dataWrappedByPromise.json())
        .then((data) => {
            dispatch(
                getBatchTicketsSuccess({ batchTickets: data, isLoading: false })
            );
        })
        .catch((error) => {
            return onError(error.message);
        });
};
